import { render, staticRenderFns } from "./RunList.vue?vue&type=template&id=2dafe026&scoped=true&"
import script from "./RunList.vue?vue&type=script&lang=ts&"
export * from "./RunList.vue?vue&type=script&lang=ts&"
import style0 from "./RunList.vue?vue&type=style&index=0&id=2dafe026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dafe026",
  null
  
)

export default component.exports